import DashboardTitleView from "./DashboardTitleView";

function DashboardTitle() {
  return <DashboardTitleView />;
}

export default DashboardTitle;
